import React, {useState} from "react";
import {FormControlLabel, Slider, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";
import {makeStyles} from '@mui/styles';
import OrangeSwitch from "../../OrangeSwitch";

const useStyles = makeStyles((theme) => ({
    switchLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
}));

const ManualScoreApplicationDetails = ({updateScore, cvScore}) => {

    const marks = [
        {
            value: 10,
            label: 'max 10',
        },
    ];

    const [scores, setScores] = useState(cvScore);
    const classes = useStyles();

    const handleCheckedChange = (e) => {
        const {name, checked} = e.target;
        setScores((prevScore) => ({
            ...prevScore,
            [name]: (checked),
        }));

        updateScore("applicationDetailsScore", {...scores, [name] : checked})
    }

    const handleSliderChange = (e) => {
        const {name, value} = e.target;
        setScores((prevScore) => ({
            ...prevScore,
            [name]: value,
        }));
        updateScore("applicationDetailsScore", {...scores, [name] : value})
    }

    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Paper className={"manual-score-header"} elevation={0} padding={"5%"}>
                <h2-white>Manually score this application</h2-white>
            </Paper>

            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Application Details
                    </h3>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width: "100%", marginLeft: "0px"}}
                        label="ID or passport loaded"
                        checked={scores?.id}
                        onChange={(e) => {handleCheckedChange(e)}}
                        data-testid={"id"}
                        name={"id"}
                        classes={{label: classes.switchLabel}}
                        labelPlacement="start"
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        label="Candidate summary loaded"
                        checked={scores?.coverLetter}
                        onChange={(e) => {handleCheckedChange(e)}}
                        labelPlacement="start"
                        data-testid={"coverLetter"}
                        name={"coverLetter"}
                        classes={{label: classes.switchLabel}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Grammatically correct
                    </Typography>
                    <Slider
                        maxWidth
                        style={{color: "#FF6600"}}
                        name={"grammar"}
                        min={0}
                        data-testid={"grammar"}
                        value={scores?.grammar}
                        step={1}
                        max={10}
                        valueLabelDisplay="auto"
                        onChange={(e) => {handleSliderChange(e)}}
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Relevance
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        onChange={(e) => {handleSliderChange(e)}}
                        maxWidth
                        min={0}
                        step={1}
                        value={cvScore?.relevance}
                        max={10}
                        data-testid={"relevance"}
                        valueLabelDisplay="auto"
                        name={"relevance"}
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}/>
            </Grid>
        </Box>
    )
}
export default ManualScoreApplicationDetails;